export const initialTelasDisponiveis = {
  notificacao_participante: false,
  notificacao_recebimento_mensal: false,
  grafico_rendimento: false,
  extrato_conta_ativo: false,
  tabela_contribuicao: false,
  percentual_contribuicao: false,
  relatorio_contribuicao: false,
  aporte: false,
  segunda_via_boleto: false,
  att_dados_cadastrais: false,
  incluir_excluir_dependente: false,
  incluir_excluir_beneficiario: false,
  simular_beneficio: false,
  contracheque: false,
  informe_rendimento: false,
  abono_anual: false,
  simular_emprestimo: false,
  contratos_aberto: false,
  cpa: false,
  comunicacao_plano: false,
  extrato_cnpc: false,
  reserva_matematica: false,
  migracao_reserva: false,
  regime_tributacao: false,
  questionario_investidor: false,
  alterar_perfil: false,
  historico_perfil: false,
  memoria_calculo: false,
  extrato_aposentadoria: false,
  extrato_opcao: false,
  parcela_adicional: false,
  saque_vista: false,
  transformacao_reserva: false,
  simular_conversao_beneficio: false,
  alterar_recebimento: false,
  transformacao_reserva_planoA: false,
  saude_financeira: false,
  resgate_parcial: false,
};

export const initialPersonalizacao = {
  contracheque: true,
  contribuicoes: true,
  investimentos: true,
  outros: true,
  saldo: true,
  simulador: true,
  simularContratar: true,
  transparencia: true,
  noticias: true,
  extratoConta: true,
  institutos: true,
  saudeFinanceira: true,
};

export const initialState = {
  telasDisponiveis: {
    data: initialTelasDisponiveis,
    loading: false,
    error: false,
  },
  personalizacao: { data: initialPersonalizacao, loading: false, error: false },
  listaRequerimentos: { data: [], loading: false, error: false },
  dataCorte: { data: {}, loading: false, error: false },
  menuAtendimentoVirtual: { data: [], loading: false, error: false },
  tema: {
    codCorPrincipal: undefined,
    nomeCorPrincipal: undefined,
    codCorHover: undefined,
    codCorFocus: undefined,
    codCorLaranja: '#e87400',
  },
  recuperacaoSenha: {
    email: undefined,
    telefone: undefined,
    matricula: undefined,
    token: undefined,
    etapa: undefined,
  },
  temporizador: {
    tempo: undefined,
    situacao: undefined,
  },
};
